import {
  brands,
  categories,
  subCategories,
  years,
  seasons,
  markets,
  channels,
  countries,
  divisions,
  departments,
  vendors,
  mills,
  vendorGroups,
  preInit,
  initialize,
  isLoaded
} from './definition'

import {
  getBrands,
  getCategories,
  getSubCategories,
  getYears,
  getSeasons,
  getMarkets,
  getChannels,
  getCountries,
  getDivisions,
  getDepartments,
  getVendors,
  getMills,
  getVendorMappingList,
  getVendorGroups
} from '../service.js'

import {
  USER,
  CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES
} from 'src/store/definition'

import { getClientUserInactiveTimeout } from 'src/services/common'

export default {
  [preInit] ({ getters, commit }) {
    const user = getters[USER]
    return new Promise((resolve, reject) => {
      Promise.all([
        getCategories(user.token),
        getClientUserInactiveTimeout(user.token)
      ]).then(results => {
        let [
          categoryList,
          clientUserInactiveTimeoutInMinutes
        ] = [...results]
        if (clientUserInactiveTimeoutInMinutes) {
          commit(CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES, clientUserInactiveTimeoutInMinutes)
        }
        if (user.userGroupId === 2) {
          if (user.categoryCodeList.length > 0) {
            let userCategoryCodeList = user.categoryCodeList
            categoryList = categoryList.filter(category => userCategoryCodeList.indexOf(category.masterCategoryCode) !== -1)
          }
        }
        commit(categories, categoryList)
        resolve()
      }).catch(({ message }) => {
        reject({ message })
      })
    })
  },
  [initialize] ({ getters, commit }) {
    return new Promise((resolve, reject) => {
      if (!getters[isLoaded]) {
        const token = getters[USER].token
        Promise.all([
          getBrands(token),
          // getCategories(),
          getSubCategories(token),
          getYears(token),
          getSeasons(token),
          getMarkets(token),
          getChannels(token),
          getCountries(token),
          getDivisions(token),
          getDepartments(token),
          getVendors(token),
          getMills(token),
          getVendorGroups(token)
        ]).then(resources => {
          let [brandList, subCategoryList, yearList, seasonList, marketList, channelList, countryList, divisionList, departmentList, vendorList, millList, vendorGroupList] = resources
          new Promise((resolve, reject) => {
            let user = getters[USER]
            if (user.userGroupId === 2) {
              if (user.brandCodeList.length > 0) {
                let userBrandCodeList = user.brandCodeList
                brandList = brandList.filter(brand => userBrandCodeList.indexOf(brand.code) !== -1)
              }
              resolve()
            } else if (user.userGroupId === 4) {
              if (user.vendorList.length > 0) {
                let vendorCodeList = user.vendorList.map(vendor => vendor.vendorCode)
                getVendorMappingList({
                  vendorCodeList,
                  token: user.token
                }).then(validVendorList => {
                  let map = validVendorList.reduce((map, vendor) => {
                    map[vendor.vendorCode] = true
                    return map
                  }, {})
                  vendorList = vendorList.filter(vendor => map[vendor.code])
                  console.info('vendorGroupList')
                  console.info(vendorGroupList)
                  vendorGroupList = getVendorGroupList(vendorGroupList, user.vendorList)
                  console.info(vendorGroupList)
                  resolve()
                }).catch(() => {
                  vendorList = []
                  resolve()
                })
              } else {
                vendorList = []
                resolve()
              }
            } else {
              resolve()
            }
          }).then(() => {
            // console.log(_.cloneDeep(vendorList))
            commit(brands, brandList)
            // commit(categories, categoryList)
            commit(subCategories, subCategoryList)
            commit(years, yearList)
            commit(seasons, seasonList)
            commit(markets, marketList)
            commit(channels, channelList)
            commit(countries, countryList)
            commit(divisions, divisionList)
            commit(departments, departmentList)
            commit(vendors, vendorList)
            commit(mills, millList)
            commit(vendorGroups, vendorGroupList)
            commit(isLoaded, true)
            resolve()
          }).catch(error => {
            console.log(error)
            commit(isLoaded, true)
          })
        }).catch(({ message }) => {
          reject({ message })
          commit(isLoaded, true)
        })
      }
    })
  }
}

export const getVendorGroupList = function (vendorGroupList, vendorList) {
  console.info('come in')
  let list = []
  vendorGroupList.forEach(item => {
    let isMatch = false
    vendorList.forEach(itemVendor => {
      if (item.code === itemVendor.vendorGroupProfileCode) {
        isMatch = true
      }
    })
    if (isMatch) {
      list.push(item)
    }
  })
  return list
}



// WEBPACK FOOTER //
// ./src/components/common/store/actions.js